import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Navbar, Nav, Dropdown, Offcanvas } from 'react-bootstrap';
import classNames from 'classnames';
import AppContext from 'context/Context';
import Logo from 'components/common/Logo';
import NavbarTopDropDownMenus from './NavbarTopDropDownMenus';
import { navbarBreakPoint, topNavbarBreakpoint } from 'config';
import TopNavRightSideNavItem from './TopNavRightSideNavItem';
import { useLocation, useNavigate } from 'react-router-dom';
import NavItems from './Navitem';
import AuthModalHandler from 'components/authentication/signup-login/AuthModalHandler';
import { useAuth } from 'components/authentication/signup-login/AuthContext';
import { GiHamburgerMenu } from "react-icons/gi";

const NavbarTop = () => {
  const {
    config: { showBurgerMenu, navbarPosition, navbarCollapsed },
    setConfig
  } = useContext(AppContext);

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isChat = pathname.includes('chat');

  const [showDropShadow, setShowDropShadow] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState('login');
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const { user, isAuthenticated, logout } = useAuth();

  const handleBurgerMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const handleCloseMobileMenu = () => {
    setShowMobileMenu(false);
  };

  const setDropShadow = () => {
    const el = document.documentElement;
    if (el.scrollTop > 0) {
      setShowDropShadow(true);
    } else {
      setShowDropShadow(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', setDropShadow);
    return () => window.removeEventListener('scroll', setDropShadow);
  }, []);

  const burgerMenuRef = useRef();

  const handleLoginClick = () => {
    setAuthMode('login');
    setShowAuthModal(true);
    handleCloseMobileMenu();
  };

  const handleSignUpClick = () => {
    setAuthMode('signup');
    setShowAuthModal(true);
    handleCloseMobileMenu();
  };

  const handleCloseAuthModal = () => {
    setShowAuthModal(false);
  };

  const handleLoginSuccess = (response) => {
    // Handle login success
  };

  const handleSignUpSuccess = (response) => {
    // Handle signup success
  };

  const handleLogout = () => {
    logout(navigate);
    handleCloseMobileMenu();
  };

  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
      handleCloseMobileMenu();
    }
  };

  const getUserInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  // Desktop User Avatar Dropdown
  const UserAvatar = () => (
    <Dropdown align="end">
      <Dropdown.Toggle
        as="div"
        className="d-flex align-items-center"
        style={{
          cursor: 'pointer',
          border: 'none',
          background: 'none'
        }}
      >
        <div
          className="d-flex align-items-center justify-content-center text-white fw-bold"
          style={{
            width: '32px',
            height: '32px',
            backgroundColor: '#007bff',
            fontSize: '14px',
            transition: 'all 0.2s ease',
            borderRadius: '4px'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 123, 255, 0.2)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          {getUserInitials(user?.name)}
        </div>
      </Dropdown.Toggle>

   <Dropdown.Menu className="shadow border-0" style={{ minWidth: '200px', borderRadius: '0.5rem' }}>
        <div className="px-3 py-2 bg-light" style={{ borderRadius: '0.5rem 0.5rem 0 0' }}>
          <div className="fw-bold" style={{ fontSize: '14px', color: '#000' }}>
            {user?.name || 'User'}
          </div>
          <div className="text-muted" style={{ fontSize: '12px' }}>
            {user?.email || ''}
          </div>
        </div>
        <Dropdown.Divider className="my-0" />
        <Dropdown.Item
          onClick={() => navigate('/user-profile')}
          className="d-flex align-items-center py-2"
          style={{ color: '#000', cursor: 'pointer' }}
        >
          <i className="fas fa-user me-2"></i>
          Profile
        </Dropdown.Item>
        {user?.is_admin && (
          <Dropdown.Item
            onClick={() => navigate('/adminconfig')}
            className="d-flex align-items-center py-2"
            style={{ color: '#000', cursor: 'pointer' }}
          >
            <i className="fas fa-cog me-2"></i>
            Admin Console
          </Dropdown.Item>
        )}
        <Dropdown.Item
          onClick={handleLogout}
          className="d-flex align-items-center py-2"
          style={{ color: '#dc3545' }}
        >
          <i className="fas fa-sign-out-alt me-2" style={{ color: '#dc3545' }}></i>
          Logout
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
  // Desktop menu items
 const getDesktopMenuItems = () => {
    if (isAuthenticated) {
      return [
        { label: 'Home', path: '/' },
        { label: 'About CDAP', path: '/about-cdap' },
        { label: 'Demo', path: '/demo' }, 
        { label: 'WorkSpace', path: '/space' }
      ];
    } else {
      return [
        { label: 'Home', path: '/' },
        { label: 'About CDAP', path: '/about-cdap' }, 
        { label: 'Demo', path: '/demo' }, 
        { label: 'Login', action: handleLoginClick },
        { label: 'Sign Up', action: handleSignUpClick }
      ];
    }
  };
  // Mobile menu items
  const getMobileMenuItems = () => {
    if (isAuthenticated) {
      const items = [
        { label: 'Home', path: '/', icon: 'fas fa-home' },
        { label: 'About CDAP', path: '/about-cdap', icon: 'fas fa-info-circle' }, 
        { label: 'Demo', path: '/demo' }, 
        { label: 'WorkSpace', path: '/space', icon: 'fas fa-briefcase' },
        { label: 'Profile', path: '/user-profile', icon: 'fas fa-user' }
      ];
      
      // Add Admin Config between Profile and Logout if user is admin
      if (user?.is_admin) {
        items.push({ label: 'Admin Console', path: '/adminconfig', icon: 'fas fa-cog' });
      }
      
      items.push({ label: 'Logout', action: handleLogout, icon: 'fas fa-sign-out-alt', danger: true });
      
      return items;
    } else {
      return [
        { label: 'Home', path: '/', icon: 'fas fa-home' },
        { label: 'About CDAP', path: '/about-cdap', icon: 'fas fa-info-circle' },
        { label: 'Demo', path: '/demo' },  
        { label: 'Login', action: handleLoginClick, icon: 'fas fa-sign-in-alt' },
        { label: 'Sign Up', action: handleSignUpClick, icon: 'fas fa-user-plus' }
      ];
    }
  };

  return (
    <>
      <Navbar
        className={classNames('navbar-glass fs--1 navbar-top sticky-kit', {
          'navbar-glass-shadow': showDropShadow && !isChat
        })}
        expand={false}
        style={{ background: 'linear-gradient(to right, #18275f, #0b1e6bff, #001f9c, #296eff, #4d8cff, #6fa8ff) !important' }}
      >
        <div className="container-fluid col">


          {/* Logo */}
          <Logo at="navbar-top" width={20} id="topLogo" className="mx-sm-0" />

          {/* Desktop Navigation - Hidden on mobile 
          <Nav className="d-none d-lg-flex flex-row justify-content-center mx-auto">*/}
         <Nav className="d-none d-lg-flex flex-row ms-auto align-items-center text-white" >

  {getDesktopMenuItems().map((item, index) => (
    <Nav.Link
      key={index}
      onClick={() => {
        if (item.external && item.path) {
          window.open(item.path, '_blank', 'noopener,noreferrer');
        } else if (item.path) {
          handleNavigation(item.path);
        } else if (item.action) {
          item.action();
        }
      }}
      className="px-3"
      style={{ cursor: 'pointer', color: '#fff' }}
    >
      {item.label}
    </Nav.Link>
  ))}

</Nav>
          {/* Hamburger Menu Button - Only visible on mobile */}

  <button
    className="navbar-toggler border-0 d-lg-none"
    type="button"
    onClick={handleBurgerMenu}
    aria-label="Toggle navigation"
    style={{ color: '#fff' }}
  >
    <span  style={{ color: '#fff' }}><GiHamburgerMenu /></span>
  </button>



          {/* Desktop Avatar - Hidden on mobile */}
          {isAuthenticated && (
            <div className="d-none d-lg-block ">
              <UserAvatar />
            </div>
          )}
        </div>
      </Navbar>

      {/* Mobile Offcanvas Menu */}
      <Offcanvas
        show={showMobileMenu}
        onHide={handleCloseMobileMenu}
        placement="start"
        className="d-lg-none"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <Logo at="navbar-top" width={35} />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {/* User Info Section for logged in users */}
          {isAuthenticated && (
            <div className="mb-4 pb-3 border-bottom">
              <div className="d-flex align-items-center">
                <div
                  className="d-flex align-items-center justify-content-center text-white fw-bold me-3"
                  style={{
                    width: '48px',
                    height: '48px',
                    backgroundColor: '#007bff',
                    fontSize: '18px',
                    borderRadius: '4px'
                  }}
                >
                  {getUserInitials(user?.name)}
                </div>
                <div>
                  <div className="fw-bold">{user?.name || 'User'}</div>
                  <div className="text-muted small">{user?.email || ''}</div>
                </div>
              </div>
            </div>
          )}

          {/* Mobile Menu Items */}
          <Nav className="flex-column">
            {getMobileMenuItems().map((item, index) => (
              <Nav.Link
                key={index}
                onClick={() => {
                  if (item.external && item.path) {
                    window.open(item.path, '_blank', 'noopener,noreferrer');
                  } else if (item.path) {
                    handleNavigation(item.path);
                  } else if (item.action) {
                    item.action();
                  }
                }}
                className={classNames('py-3 d-flex align-items-center', {
                  'text-danger': item.danger
                })}
                style={{ cursor: 'pointer' }}
              >
                {/* {item.icon && <i className={`${item.icon} me-3`}></i>} */}
                <span>{item.label}</span>
              </Nav.Link>
            ))}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Auth Modal */}
      <AuthModalHandler
        show={showAuthModal}
        handleClose={handleCloseAuthModal}
        initialMode={authMode}
        onLoginSuccess={handleLoginSuccess}
        onSignUpSuccess={handleSignUpSuccess}
      />
    </>
  );
};

export default NavbarTop;